// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"84620cad","438":"89621ad8","441":"c4936142","545":"d31a736e","664":"4d11aa5a"}[chunkId] + ".chunk.js";
};